import { Component } from '@angular/core';

@Component({
  selector: 'app-about-section',
  templateUrl: './about-section.component.html',
  styleUrls: ['./about-section.component.scss']
})
export class AboutSectionComponent {
  collabLogos = [
    { src: 'assets/image/redesign/collab/cathay.png',    alt: 'Cathay Pacific' },
    { src: 'assets/image/redesign/collab/klook.png',     alt: 'Klook' },
    { src: 'assets/image/redesign/collab/foodpanda.png', alt: 'Foodpanda' },
    { src: 'assets/image/redesign/collab/keeta.png',     alt: 'Keeta' },
    { src: 'assets/image/redesign/collab/neighbuy.png',  alt: '鄰住買 Neighbuy' }
  ];
}
